import { Snackbar } from '@mui/material'
import MuiAlert from '@mui/material/Alert'
import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setAlert } from '../features/appSlice'
import { AlertPosition } from '../helpers/Constants'

const CustomAlert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

// app level alerts
const Alert = () => {
    const dispatch = useDispatch()
    const { message, type, open } = useSelector((state) => state.app.alert)

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return
        }
        dispatch(setAlert({ open: false }))
    }
    return (
        <Snackbar
            open={open}
            onClose={handleClose}
            autoHideDuration={4000}
            anchorOrigin={{
                vertical: AlertPosition.vertical,
                horizontal: AlertPosition.horizontal,
            }}
            // Above BhanzuBot's launcher (56px, 16px from the bottom on a
            // phone and 24px wider), so a toast never covers it. The phone
            // value is the plain one (not an xs media rule), so it also
            // overrides MUI's own bottom where no media query is read.
            sx={(theme) => ({
                bottom: 80,
                [theme.breakpoints.up('sm')]: { bottom: 88 },
            })}
        >
            <CustomAlert severity={type} sx={{ width: '100%' }}>
                {message}
            </CustomAlert>
        </Snackbar>
    )
}

export default Alert
